import styled from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
  float: left;
  width: 100%;
  margin: 1rem 0;
  border-top: 1px solid ${props => props.theme.colors.boxBorderLight};
  border-bottom: 1px solid ${props => props.theme.colors.boxBorderDark};
`;

const PcBox = styled(DefaultBox)`
  display: block;
`;

const MobileBox = styled(DefaultBox)`
  display: none;
`;

export const LanguageSwitcherSectionSeparatorDefaultBox = styledByDevice(PcBox, MobileBox);
